import { render, staticRenderFns } from "./ListFiltroModalItemInputProduto.vue?vue&type=template&id=535afef7"
import script from "./ListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"
export * from "./ListFiltroModalItemInputProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports